import React, { useEffect, useState, useContext } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import DatePicker from "react-datepicker";
import Box from "@mui/material/Box";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import moment from "moment";
import { token_api } from "../../Utils/Network";
import Snackbar from "@mui/material/Snackbar";
// import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from "@mui/material/Alert";

const dayOptions = [
  { label: "Sun", value: "sunday" },
  { label: "Mon", value: "monday" },
  { label: "Tue", value: "tuesday" },
  { label: "Wed", value: "wednesday" },
  { label: "Thu", value: "thursday" },
  { label: "Fri", value: "friday" },
  { label: "Sat", value: "saturday" },
];
const batchData = {
  colour: "#D581D6",
  sunday: true,
  monday: true,
  tuesday: true,
  wednesday: true,
  thursday: true,
  friday: true,
  saturday: true,
  discount_type: "Percentage",
  commence: moment(),
  conclude: moment(),
  session_name: "",
  price: "",
  duration: 60,
  capacity: 1,
};

// Shared styling for a clean, card-based settings layout.
const cardSx = {
  background: "#fff",
  borderRadius: "14px",
  boxShadow: "0 1px 3px rgba(16,24,40,.06), 0 1px 2px rgba(16,24,40,.08)",
  border: "1px solid #eef0f4",
  p: { xs: 2, md: 3 },
  mb: 3,
};
const labelStyle = {
  color: "#313E6C",
  fontWeight: 600,
  fontSize: 13,
  margin: "0 0 6px",
};
const selectStyle = {
  width: "100%",
  padding: "11px 12px",
  borderRadius: "10px",
  border: "1px solid #d5d9e0",
  fontSize: 14,
  background: "#fff",
  color: "#313E6C",
};

const Setting = () => {
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const [data, setData] = useState(batchData);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [open, setOpen] = React.useState(false);
  const [meetLink, setMeetLink] = useState("");
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  const [dataPresent, setDataPresent] = useState(false);

  // Packages are created on the Packages page; here we only list them so slots
  // can be created for a chosen package.
  const [packages, setPackages] = useState([]);
  const [selectedPackageId, setSelectedPackageId] = useState("");
  const [creatingSlots, setCreatingSlots] = useState(false);

  const fetchPackages = () => {
    token_api
      .get("counseling/v1/counselling_packages/?active=true")
      .then((res) => {
        const list = res?.data?.data?.results || res?.data?.data || res?.data?.results || res?.data || [];
        setPackages(Array.isArray(list) ? list : []);
      })
      .catch((err) => console.error("Failed to load packages:", err));
  };

  // Picking a package fills price + duration from it, so slots inherit them.
  const handleSelectPackage = (id) => {
    setSelectedPackageId(id);
    const pkg = packages.find((p) => String(p.id) === String(id));
    if (pkg) {
      setData((prev) => ({
        ...prev,
        price: pkg.selling_price ?? prev.price,
        duration: pkg.session_time ?? prev.duration,
        session_name: prev.session_name || pkg.name,
      }));
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const createBatchHandler = () => {
    if (creatingSlots) return; // avoid double-submit
    if (!selectedPackageId) {
      alert("Please select a package first — slots are created for a package.");
      return;
    }
    if (!data.session_name || data.price === "") {
      alert("Please fill all the details (Session Name and Price are required).");
      return;
    }

    if (!meetLink || !meetLink.trim()) {
      setError(true);
      setHelperText("Google Meet Link is required. Please enter a valid Google Meet link.");
      alert("Please enter a Google Meet Link. A valid Google Meet link is required to create slots.");
      return;
    }

    const googleMeetRegex =
      /^https:\/\/meet\.google\.com\/[a-zA-Z0-9\-]{10,14}$/;
    if (!googleMeetRegex.test(meetLink.trim())) {
      setError(true);
      setHelperText("Please enter a valid Google Meet link (e.g. https://meet.google.com/abc-defg-hij).");
      alert("Please enter a valid Google Meet link (e.g. https://meet.google.com/abc-defg-hij).");
      return;
    }

    const daysList = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    const myArray = [];
    for (const [key, value] of Object.entries(data)) {
      if (typeof value === "boolean" && value) {
        let getIndex = daysList.indexOf(key) + 1;
        if (getIndex > 0) myArray.push(getIndex);
      }
    }

    if (myArray.length === 0) {
      alert("Please select at least one day of the week.");
      return;
    }

    // Time window must be later than start and at least one session long.
    const windowMins = moment(data.conclude).diff(moment(data.commence), "minutes");
    const sessionMins = +data.duration || 60;
    if (windowMins <= 0) {
      alert("End time must be later than Start time.");
      return;
    }
    if (windowMins < sessionMins) {
      alert(
        `The time window is ${windowMins} min, but each session is ${sessionMins} min. ` +
        `Please pick a window of at least ${sessionMins} minutes.`
      );
      return;
    }

    const effectiveEndDate = endDate < startDate ? startDate : endDate;
    const coms = moment(data.commence).format("HH:mm:ss");
    const conc = moment(data.conclude).format("HH:mm:ss");
    const starts = moment(startDate).format("DD-MM-YYYY");
    const ends = moment(effectiveEndDate).format("DD-MM-YYYY");

    const demo = {
      session_name: data.session_name,
      price: +data.price,
      start: starts,
      end: ends,
      commence: coms,
      conclude: conc,
      days: myArray,
      duration: +data.duration || 60,
      capacity: +data.capacity || 1,
      meet_link: meetLink.trim(),
      package: selectedPackageId || undefined,
    };

    setCreatingSlots(true);
    token_api
      .post("counseling/v2/all_slots/register_instructor/", demo)
      .then((res) => {
        if (res.status === 200) {
          if (meetLink) {
            try {
              localStorage.setItem("counsellor_last_meet_link", meetLink.trim());
            } catch (e) {}
          }
          setOpen(true);
        }
      })
      .catch((err) => {
        console.error("Slot creation error:", err?.response?.data || err);
        alert(err?.response?.data?.info || err?.response?.data?.message || "Failed to create slots. Please check timings.");
      })
      .finally(() => setCreatingSlots(false));
  };

  useEffect(() => {
    // 1. Immediately prefill from localStorage if available
    try {
      const cachedLink = localStorage.getItem("counsellor_last_meet_link");
      if (cachedLink) {
        setMeetLink(cachedLink);
        setDataPresent(true);
      }
    } catch (e) {}

    // 2. Fetch fresh meet link from backend
    getuserMeetLink();
    fetchPackages();
  }, []);

  const getuserMeetLink = () => {
    token_api
      .get(`/profile/instructor_meet_link/`)
      .then((res) => {
        const link =
          res?.data?.data?.[0]?.meet_link ??
          res?.data?.data?.meet_link ??
          res?.data?.[0]?.meet_link ??
          res?.data?.meet_link ??
          "";
        console.log("getuserMeetLink:", link);
        if (link && link.trim() !== "") {
          setMeetLink(link.trim());
          setDataPresent(true);
          try {
            localStorage.setItem("counsellor_last_meet_link", link.trim());
          } catch (e) {}
        }
      })
      .catch((err) => {
        console.log("Error fetching meet link:", err);
      });
  };

  const handleMeetLinks = (e) => {
    const googleMeetRegex =
      /^https:\/\/meet\.google\.com\/[a-zA-Z0-9\-]{10,14}$/;
    const { value } = e.target;
    setMeetLink(value);
    if (value && !googleMeetRegex.test(value.trim())) {
      setError(true);
      setHelperText("Please enter a valid Google Meet link (e.g. https://meet.google.com/abc-defg-hij).");
    } else {
      setError(false);
      setHelperText("");
    }
  };

  const saveMeetLink = () => {
    if (!meetLink || error) {
      alert("Please enter a valid Google Meet link before saving.");
      return;
    }
    const cleanLink = meetLink.trim();
    token_api
      .post(`/profile/instructor_meet_link/`, { meet_link: cleanLink })
      .then((res) => {
        setDataPresent(true);
        try {
          localStorage.setItem("counsellor_last_meet_link", cleanLink);
        } catch (e) {}
        alert("Google Meet link updated successfully!");
      })
      .catch((err) => {
        console.error("Error updating meet link:", err);
        // Fallback to patch
        token_api
          .patch(`/profile/instructor_meet_link/`, { meet_link: cleanLink })
          .then((res) => {
            setDataPresent(true);
            try {
              localStorage.setItem("counsellor_last_meet_link", cleanLink);
            } catch (e) {}
            alert("Google Meet link updated successfully!");
          })
          .catch((patchErr) => {
            alert(patchErr?.response?.data?.detail || "Failed to update Google Meet link.");
          });
      });
  };

  const selectedPackage = packages.find(
    (p) => String(p.id) === String(selectedPackageId)
  );

  return (
    <div style={{ background: "#f5f7fb", minHeight: "100%", padding: "24px 0" }}>
      <div style={{ maxWidth: 1120, margin: "0 auto", padding: "0 16px" }}>

        {/* ============ Card 1: Create New Session ============ */}
        <Box sx={cardSx}>
          <h2 style={{ color: "#313E6C", margin: "0 0 4px" }}>Create New Session</h2>
          <p style={{ color: "#696984", margin: "0 0 20px", fontSize: 14 }}>
            Slots are created for a package. Choose a package to begin.
          </p>

          {/* Step 1 — always visible */}
          <div style={{ maxWidth: 560 }}>
            <p style={labelStyle}>Step 1 · Select Package *</p>
            <select
              value={selectedPackageId}
              onChange={(e) => handleSelectPackage(e.target.value)}
              style={selectStyle}
            >
              <option value="">-- Choose a package --</option>
              {packages.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name} — ₹{p.selling_price} · {p.sessions} session(s) · {p.session_time} min
                </option>
              ))}
            </select>
          </div>

          {!selectedPackageId ? (
            <div
              style={{
                marginTop: 20,
                padding: "16px 18px",
                borderRadius: 12,
                background: "#f0f6ff",
                border: "1px dashed #b9d3f2",
                color: "#3a5a86",
                fontSize: 14,
              }}
            >
              👆 Select a package above to configure days, timings and create slots.
            </div>
          ) : (
            <>
              {/* Selected package summary */}
              {selectedPackage && (
                <div
                  style={{
                    marginTop: 16,
                    display: "inline-flex",
                    gap: 10,
                    flexWrap: "wrap",
                    alignItems: "center",
                    padding: "10px 14px",
                    borderRadius: 10,
                    background: "#e7f6f1",
                    border: "1px solid #bfe6da",
                  }}
                >
                  <span style={{ fontWeight: 700, color: "#12878b" }}>
                    {selectedPackage.name}
                  </span>
                  <span style={{ color: "#38665c", fontSize: 13 }}>
                    ₹{selectedPackage.selling_price} · {selectedPackage.sessions} session(s) ·{" "}
                    {selectedPackage.session_time} min — price &amp; duration auto-filled
                  </span>
                </div>
              )}

              <div style={{ height: 1, background: "#eef0f4", margin: "22px 0" }} />
              <p style={{ ...labelStyle, fontSize: 14, marginBottom: 16 }}>
                Step 2 · Session Details
              </p>

              {/* Consistent look for the date/time pickers (they aren't MUI). */}
              <style>{`
                .setting-picker .react-datepicker-wrapper { width: 100%; }
                .setting-picker .rc-time-picker { width: 100%; display: block; }
                .setting-picker input,
                .setting-picker .rc-time-picker-input {
                  width: 100% !important;
                  height: 42px;
                  border: 1px solid #d5d9e0;
                  border-radius: 10px;
                  padding: 8px 14px;
                  font-size: 14px;
                  color: #313E6C;
                  background: #fff;
                  box-sizing: border-box;
                  outline: none;
                  transition: border-color .15s ease, box-shadow .15s ease;
                }
                .setting-picker input::placeholder,
                .setting-picker .rc-time-picker-input::placeholder { color: #9aa4b2; }
                .setting-picker input:hover,
                .setting-picker .rc-time-picker-input:hover { border-color: #a9b2c0; }
                .setting-picker input:focus,
                .setting-picker .rc-time-picker-input:focus {
                  border-color: #12878b;
                  box-shadow: 0 0 0 3px rgba(18,135,139,.14);
                }
                /* clear (x) button on the time picker */
                .setting-picker .rc-time-picker-clear {
                  top: 10px; right: 12px;
                }
                .setting-picker .rc-time-picker-clear-icon:after {
                  color: #9aa4b2; font-size: 14px;
                }
                .rc-time-picker-panel-select { font-size: 14px; }
              `}</style>

              <Grid container spacing={2.5}>
                {/* --- Basics --- */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Session Name"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={data.session_name}
                    onChange={(e) => setData({ ...data, session_name: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Google Meet Link (Required)"
                    variant="outlined"
                    size="small"
                    fullWidth
                    placeholder="https://meet.google.com/xxx-yyyy-zzz"
                    value={meetLink}
                    onChange={(e) => handleMeetLinks(e)}
                    error={error}
                    helperText={helperText || "Sent automatically in the booking confirmation email."}
                  />
                </Grid>

                {/* --- Availability --- */}
                <Grid item xs={12}>
                  <div style={{ height: 1, background: "#eef0f4", margin: "6px 0 2px" }} />
                  <p style={{ ...labelStyle, color: "#8a93a6", textTransform: "uppercase", letterSpacing: 0.6, fontSize: 12 }}>
                    Availability
                  </p>
                  <p style={labelStyle}>Days</p>
                  <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 2 }}>
                    <div style={{ display: "inline-flex", alignItems: "center" }}>
                      <Checkbox
                        checked={
                          data.sunday &&
                          data.monday &&
                          data.tuesday &&
                          data.wednesday &&
                          data.thursday &&
                          data.friday &&
                          data.saturday
                        }
                        onChange={(e, v) =>
                          setData({
                            ...data,
                            sunday: v,
                            monday: v,
                            tuesday: v,
                            wednesday: v,
                            thursday: v,
                            friday: v,
                            saturday: v,
                          })
                        }
                        style={{ color: "#12878b" }}
                      />
                      <span>Select all</span>
                    </div>
                    {dayOptions.map((d) => (
                      <div
                        key={d.value}
                        style={{ display: "inline-flex", alignItems: "center" }}
                      >
                        <Checkbox
                          checked={data[d.value]}
                          style={{ color: "#12878b" }}
                          onChange={(e, checkedState) =>
                            setData({ ...data, [d.value]: checkedState })
                          }
                        />
                        <span>{d.label}</span>
                      </div>
                    ))}
                  </div>
                </Grid>

                {/* Date range */}
                <Grid item xs={12} md={6}>
                  <p style={labelStyle}>Date range</p>
                  <div style={{ display: "flex", gap: 12 }}>
                    <div className="setting-picker" style={{ flex: 1 }}>
                      <span style={{ display: "block", fontSize: 11, color: "#8a93a6", margin: "0 0 4px" }}>Start</span>
                      <DatePicker
                        selected={startDate}
                        minDate={new Date()}
                        onChange={(date) => {
                          setStartDate(date);
                          if (endDate < date) setEndDate(date);
                        }}
                      />
                    </div>
                    <div className="setting-picker" style={{ flex: 1 }}>
                      <span style={{ display: "block", fontSize: 11, color: "#8a93a6", margin: "0 0 4px" }}>End</span>
                      <DatePicker
                        selected={endDate}
                        minDate={startDate}
                        onChange={(date) => setEndDate(date)}
                      />
                    </div>
                  </div>
                </Grid>

                {/* Time range */}
                <Grid item xs={12} md={6}>
                  <p style={labelStyle}>Time range</p>
                  <div style={{ display: "flex", gap: 12 }}>
                    <div className="setting-picker" style={{ flex: 1 }}>
                      <span style={{ display: "block", fontSize: 11, color: "#8a93a6", margin: "0 0 4px" }}>Start</span>
                      <TimePicker
                        showTodayButton
                        todayLabel="now"
                        minutesStep={5}
                        value={data.commence}
                        onChange={(e, v) => setData({ ...data, commence: e })}
                        autoOk
                      />
                    </div>
                    <div className="setting-picker" style={{ flex: 1 }}>
                      <span style={{ display: "block", fontSize: 11, color: "#8a93a6", margin: "0 0 4px" }}>End</span>
                      <TimePicker
                        showTodayButton
                        todayLabel="now"
                        minutesStep={5}
                        value={data.conclude}
                        onChange={(e, v) => setData({ ...data, conclude: e })}
                        autoOk
                      />
                    </div>
                  </div>
                </Grid>

                {/* --- Slot settings --- */}
                <Grid item xs={12}>
                  <div style={{ height: 1, background: "#eef0f4", margin: "6px 0 2px" }} />
                  <p style={{ ...labelStyle, color: "#8a93a6", textTransform: "uppercase", letterSpacing: 0.6, fontSize: 12 }}>
                    Slot Settings
                  </p>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    label="Duration (minutes)"
                    variant="outlined"
                    type="number"
                    size="small"
                    fullWidth
                    value={data.duration}
                    onChange={(e) => setData({ ...data, duration: e.target.value })}
                    helperText="From package"
                  />
                </Grid>
                <Grid item xs={6} sm={4}>
                  <TextField
                    label="Price (₹)"
                    variant="outlined"
                    type="number"
                    size="small"
                    fullWidth
                    value={data.price}
                    onChange={(e) => setData({ ...data, price: e.target.value })}
                    helperText="From package"
                  />
                </Grid>
                <Grid item xs={6} sm={4}>
                  <TextField
                    label="Capacity"
                    variant="outlined"
                    type="number"
                    size="small"
                    fullWidth
                    inputProps={{ min: 1, max: 10 }}
                    value={data.capacity}
                    onChange={(e) => setData({ ...data, capacity: e.target.value })}
                    helperText="Students per slot (1-10)"
                  />
                </Grid>

                <Grid item xs={12}>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", marginTop: 8 }}>
                    <Button
                      variant="contained"
                      onClick={createBatchHandler}
                      disabled={creatingSlots}
                      style={{
                        minWidth: "12rem",
                        borderRadius: "10px",
                        height: "2.8rem",
                        backgroundColor: creatingSlots ? "#7bb8ba" : "#12878b",
                        fontWeight: 600,
                      }}
                    >
                      {creatingSlots ? "Creating slots..." : "Create Slots"}
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={saveMeetLink}
                      style={{ minWidth: "12rem", borderRadius: "10px", height: "2.8rem" }}
                    >
                      {dataPresent ? "Update Meet Link Only" : "Save Meet Link"}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </>
          )}
        </Box>

        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
            Successfully created
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

export default Setting;
